import OurTeam from "../Components/OurTeam.jsx";
import Experiences from "../Components/Experiences.jsx";
import Future from "../Components/Future.jsx";
import useFetch from '../hooks/useFetch';
import './styles/Team.scss';
import { API_URL } from "../../App.jsx";
import {AdvancedImage} from '@cloudinary/react';
import {Cloudinary} from "@cloudinary/url-gen";

export const TEAM_TYPE_LEADERSHIP = 'Leadership';
export const TEAM_TYPE_DEVELOPER = 'Developer';
export const TEAM_TYPE_ADVISOR = 'Advisor';

function Team(props) {
    const { error, loading, data } = useFetch(API_URL + '/teams?populate=*');

    const sortedData = data?.data.sort((a, b) => parseFloat(a.id) - parseFloat(b.id));

    const leaderShipData = sortedData?.filter(team => team.attributes.Type === TEAM_TYPE_LEADERSHIP);
    const expertData = sortedData?.filter(team => team.attributes.Type === TEAM_TYPE_DEVELOPER);
    const advisorData = sortedData?.filter(team => team.attributes.Type === TEAM_TYPE_ADVISOR);

    return (
    <main className='teamMainContainer'>
        <OurTeam data={leaderShipData} categori='leadership' tag='OUR TEAM' ><span> Executive </span>Leadership</OurTeam>
        <OurTeam data={expertData} categori='experts' tag='OUR TEAM'><span> Development </span>Experts</OurTeam>
        <OurTeam data={advisorData} categori='advisors' tag='OUR ADVISORY TEAM'><span> Strategic </span>Advisors</OurTeam>
        <Experiences />
    </main>
     
    )
}

export default Team;